import { AxiosRequestConfig } from "axios";
import { apis } from "service";

const BASE_URL = 'https://xxl6-bbr3-kxzs.m2.xano.io/api:'
const cancel_remit_order = BASE_URL + 'FiAQK2sE/remit_order_cancel_v3'

export const cancelRemitOrder = async (data: { 
    order_id: number,
    cancellation_reason: string,
    cancellation_charges:{
        service_provider_charges: number,
        l2_charges: number,
        customer_charges: number
    }
 }): Promise<any> => {
  const payload: AxiosRequestConfig<{
    order_id: number;
    cancellation_reason: string;
    cancellation_charges: {
      service_provider_charges: number;
      l2_charges: number;
      customer_charges: number;
    };
  }> = {
    data
  };
  return await apis.post(cancel_remit_order, payload);
};